export * from '@fhs/routing/src/routes/(tabs)/(more)/_layout';
export { default } from '@fhs/routing/src/routes/(tabs)/(more)/_layout';
